import { useAssignableMembers } from '../../hooks/useRoles';

export const NO_ASSIGNEE_LABEL = 'No one';

// The assignee's name from the team's members (one cached fetch per team); undefined until found.
export function useVirtualAppointmentAssigneeName(
    team: string,
    assigneeEmail: string | null
): string | undefined {
    const { members } = useAssignableMembers([team], Boolean(assigneeEmail));
    if (!assigneeEmail) return undefined;
    return members.find((m) => m.email === assigneeEmail)?.fullname;
}
